var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    _vm._g(
      { staticClass: "filter-side-card-switch feeds-filter-switch" },
      _vm.$listeners
    ),
    [
      _c(
        "label",
        { class: { disabled: _setup.disabled } },
        [
          _c(
            "span",
            { staticClass: "name", class: { disabled: _setup.disabled } },
            [_vm._v(_vm._s(_vm.name))]
          ),
          _vm._v(" "),
          _c(_setup.VIcon, {
            staticClass: "disabled",
            attrs: { size: 16, icon: "mdi-cancel" },
          }),
          _vm._v(" "),
          _c(_setup.VIcon, { attrs: { size: 16, icon: "mdi-check" } }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }